import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class ProfileService extends BaseService {
    static async updateProfileImage(params = {}) {
        const res = await this.post(`/profile/wallpaper`, params);
        return unwrapResponse(res);
    }
    static async getProfile(params = {}) {
        const res = await this.get(`/users/` + params.user_id);
        return unwrapResponse(res);
    }
    static async getFiles(userId, params = {}) {
        const res = await this.get(`/users/` + userId + '/files', params);
        return unwrapResponse(res);
    }
    static async updateProfile(params = {}) {
        const res = await this.post(`/update-profile`, params);
        return unwrapResponse(res);
    }
    static async changePassword(params = {}) {
        const res = await this.post(`/change-password`, params);
        return unwrapResponse(res);
    }
    static async updateUserProfile(params = {}, user_id) {
        const res = await this.post(`/profile/update-other-account/${user_id}`, params);
        return unwrapResponse(res);
    }
}
